import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"text-dark order-2 order-md-1\"><span class=\"text-muted fw-bold me-1\">2023 © </span><a href=\"https://seip-fd.gov.bd/\" target=\"_blank\" class=\"text-gray-800 text-hover-primary\">SEIP</a></div><div class=\"order-1\"><p class=\"mb-0\"> For Support : <a href=\"mailto:tms.team@tappware.com\" target=\"_blank\" class=\"text-bold fs-8 mr-2\" style=\"font-weight:600;display:inline;align-items:center;\"><i class=\"fa fa-envelope mr-2\" aria-hidden=\"true\"></i>tms.team@tappware.com </a><i class=\"fa fa-phone mr-2\" aria-hidden=\"true\" style=\"transform:rotate(90deg);\"></i> +88 01304-733951 , +88 01873-927289 </p></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex flex-column flex-md-row align-items-center justify-content-between", {
        'container-fluid': _ctx.footerWidthFluid,
        'container-xxl': !_ctx.footerWidthFluid,
      }])
    }, _hoisted_4, 2)
  ]))
}